import React from 'react'
import { EditableTitle, WContainer } from '@components/atoms'
import styles from './CodiceEticoBox.module.sass'
import useTrans from '@hooks/useTrans'
import { ArchivioDocumentiListingNode } from '@gql/graphql'
import { DocumentiCard } from '@components/molecules'

interface Props {
  documenti: ArchivioDocumentiListingNode[]
  editMode?: boolean
  className?: string
  etico?: boolean
}

const CodiceEticoBox = (props: Props) => {
  const { documenti = [], editMode = false, className = '', etico = true } = props

  const t = useTrans()

  return (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          <div className={styles.main}>
            <div className={styles.content}>
              <EditableTitle
                title={
                  etico
                    ? t('Consulta il nostro codice etico')
                    : t('Segnalazioni a organismi di vigilanza')
                }
                variant="h3"
                className={styles.title}
                editMode={editMode}
              />
            </div>
          </div>
          {documenti && documenti.length > 0 && (
            <div className={styles.list}>
              {documenti.map((doc, index) => (
                <DocumentiCard documento={doc} key={index} />
              ))}
            </div>
          )}
        </div>
      </WContainer>
    </div>
  )
}

export default CodiceEticoBox
